import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { FeaturesRoutingModule } from './features-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RegisterComponent } from './register/register.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LayoutModule } from './layout/layout.module';
import { MenuService } from './menu/menu.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClientModule } from '@angular/common/http';
import { menu } from './menu/menu';
import { SharedModule } from '@piqet-angular/shared';
import { AuthenticationService } from 'libs/data/src/lib/services/auth/authentication.service';
import { SharedService } from 'libs/data/src/lib/services/shared/shared.service';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { PurchaseThanksComponent } from './purchase-thanks/purchase-thanks.component';
import { PurchaseCancelComponent } from './purchase-cancel/purchase-cancel.component';
import { CustomMaterialsDataGridService } from './layout/custom/custom-materials/custom-materials-data-grid.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ForceChangePasswordComponent } from './force-change-password/force-change-password.component';
import { JoyrideModule } from 'ngx-joyride';
import { VerifyOtpComponent } from './verify-otp/verify-otp.component';
import { CreateUserComponent } from './create-user/create-user.component';
import { UiModule } from '@piqet-angular/ui';
import { LcaDocComponent } from './docs/lca-doc/lca-doc.component';
import { QuickReferenceComponent } from './docs/quick-reference/quick-reference.component';
import { AuthApiDocComponent } from './docs/auth-api-doc/auth-api-doc.component';
import { CtrlKFocusDirective } from './docs/shared/ctrl-k-focus.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FeaturesRoutingModule,
    LayoutModule,
    NgxCaptchaModule,
    NgSelectModule,
    HttpClientModule,
    SharedModule,
    NgOptionHighlightModule,
    NgxSpinnerModule,
    UiModule,
  ],
  providers: [MenuService, AuthenticationService, SharedService, CustomMaterialsDataGridService],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    RegisterComponent,
    ResetPasswordComponent,
    ActivateUserComponent,
    PurchaseThanksComponent,
    PurchaseCancelComponent,
    ForceChangePasswordComponent,
    VerifyOtpComponent,
    CreateUserComponent,
    LcaDocComponent,
    QuickReferenceComponent,
    AuthApiDocComponent,
    CtrlKFocusDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FeaturesModule {
  constructor(public menuService: MenuService) {
    // this.menuService.initializeMenu();
  }
}
